import { useEffect, useState } from "react"
import { Box, Stack, Typography } from "@mui/material"

export const VStudentLabel = ({ order }) => {
    const [labels, setLabels] = useState(1)

    const Label = ({name}) => (
        <Box p={1} borderRadius={2} sx={{
            border: '1px solid gray',
            minWidth: 230,
            minHeight: 30,
            textAlign: 'center'
        }}>
            <Typography fontSize={18}>{name}</Typography>
        </Box>
    )

    useEffect(() => {
        const { studentLabels } = JSON.parse(localStorage.getItem('zWarehouse'))
        setLabels(studentLabels)
    }, [])

    return (
        <Box sx={{
            margin: '1em',
            justifyContent: 'center'
        }}>
            <Stack py={2} spacing={2} sx={{
                borderBottom: '1px dashed gray'
            }}>
                {Array.from(Array(+labels).keys()).map((_, idx) => (
                    <Stack key={idx}
                        direction='row' spacing={2} justifyContent='center'>
                        <Label name={order.student} />
                        <Label name={order.student} />
                    </Stack>
                ))}
            </Stack>

        </Box>
    )
}